export default __webpack_public_path__ + "static/media/element_3.f3150ad1.jpg";